import { render, staticRenderFns } from "./Acessar.vue?vue&type=template&id=5f62d830&scoped=true&"
import script from "./Acessar.vue?vue&type=script&lang=js&"
export * from "./Acessar.vue?vue&type=script&lang=js&"
import style0 from "./Acessar.vue?vue&type=style&index=0&id=5f62d830&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f62d830",
  null
  
)

export default component.exports